import * as angular from "angular";
import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

@NgFilter({
    token: Token.TruncateFilter,
    dependencies: [
    ]
})
export class TruncateFilter {
    constructor() {
        return ((text: string, length: number, end: string) => {
            if (isNaN(length)) {
                length = 10;
            }
                
            if (!angular.isDefined(end)) {
                end = "...";
            }

            if (!text || text.length - end.length <= length) {
                return text;
            } else {
                return String(text).substring(0, length - end.length) + end;
            }
        }) as any;
    }

}
